import React from 'react';

import {
    ajax, plainDate, LabelStatusColor,
     downloadOrderLabels,
    deleteOrders, 
    getNavigation, ProfileLevels
} from '../components/globals';
import { Languages } from '../components/languages';


import { UIFilterPanel,  PageTitle, UIDataTable,  UIInput, UIButton, UIButtonPad, UICheckbox,  UISelect } from '../components/guiElements';


export class OrdersList extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.operationsClick = this.operationsClick.bind(this);
        this.listClick = this.listClick.bind(this);
        this.listChange = this.listChange.bind(this);
        this.filtersChange = this.filtersChange.bind(this);

        this.getData = this.getData.bind(this);
        this.sendOrders = this.sendOrders.bind(this);
        this.sendAllOrders = this.sendAllOrders.bind(this);
        //#endregion Methods binding

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.OrdersList[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.header = [{
                generic: { manage: 1, default: false, name: 'main', width: 4, change: this.listChange, click: null },
                caption: { type: 'checkbox', colClass: null, itemClass: 'right', value: null },
                element: { type: 'checkbox', colClass: null, itemClass: 'right', options: null, checkVisibility: true }
            },
            {
                generic: { manage: 0, name: 'orderNo', width: 13, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'date', width: 10, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'courier', width: 9, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'customer', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'labels', width: 8, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
                element: { type: 'label', colClass: null, itemClass: 'bold', options: null }
            }, {
                generic: { manage: 0, name: 'labels', width: 8, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[5] },
                element: { type: 'label', colClass: null, itemClass: 'bold', options: null }
            }, {
                generic: { manage: 0, name: 'pickStatus', width: 9, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[6] },
                element: { type: 'label', colClass: null, itemClass: 'bold', options: null }
            }, {
                generic: { manage: 4, default: null, name: 'action', width: 12, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[7] },
                element: { type: 'button', colClass: null, itemClass: 'modify', options: null }
            }];

        if (this.uc && this.uc.userRole === ProfileLevels[2]) {
            this.header.pop(); //remove action
        }

        this.listKey = 0;
        this.configs = {
            filters: {
                orderNum: { type: "text", width: "20%" },
                recipient: { type: "text", width: "20%" },
                downloaded: {
                    type: "select",
                    options: [
                        { text: "Tutti gli stati", value: "" },
                        { text: this.le.labelDownloadedStatuses[0], value: 0 },
                        { text: this.le.labelDownloadedStatuses[1], value: 1 }
                    ]
                }
            }
        };

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });
        this.appliedFilters = filters;

        //#region Automatic Support Data
        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));
        //#endregion Automatic Support Data

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.state = {
            entries: [],
            orders:[],
            managers: Array(1).fill().map((el) => (this.defaultManager.slice())),
            //modalType: 0,
            modalMsg: "",
            msgNumber: 0,
            filters: filters,
            navigation: navigation
        };
    }

    markDownloadedLabels(orders) {
        let entries = [];
        this.state.entries.forEach(el => {
            if (orders.indexOf(el[0]) >= 0)
                el[5].val = this.le.labelDownloadedStatuses[1];
            entries.push(el);
        });
        this.setState({
            entries: entries
        });
    }

    //#region Events
    findSelectedOrders() {
        let orders = [];
        for (var i = 1; i < this.state.managers.length; i++) {
            if (this.state.managers[i][0/*1*/])  // is the checkbox checked?
            {
                if ((i - 1) < this.state.entries.length) {
                    let orderNum = this.state.entries[i - 1][0];
                    let order = this.findOrder(orderNum);
                    if (order != null)
                        orders.push(order);
                }
            }
        }
        return orders;
    }

    findOrder(orderNum)
    {
       let order= this.state.orders.find(a => a.orderNum== orderNum);

        if (order == undefined)
            return null;
        return order;
    }

    downloadLabels(orders) {

        try {
            let orderNums = [];
            orders.forEach((el) => {
                if (el.orderStatus != 'error'
                    && el.orderStatus != '' && el.orderStatus != 'todo')
                    orderNums.push(el.orderNum);
            });

          
            if (orderNums.length == 0) {
                this.props.popupErrorMessage(this.le.noReadyOrderSelected);
                return;
            }
                
            downloadOrderLabels(this.uc.jwtToken,orderNums, error => {                
                let msg = this.le.messages[0];
                if (error != undefined && error != null && error.hasOwnProperty("response")
                    && error.response.hasOwnProperty("status") && error.response.status == 404)
                    msg = this.leMain.messages.fileNotFound;
                this.props.popupErrorMessage(msg.messages);
            });

            this.markDownloadedLabels(orderNums);

            // aggiungere la callback a downloadOrderLabels ha troppi impatti..
            // metto un reload ad 1 sec...
            /*setTimeout(() =>
                { this.getData(this.state.navigation); }, 1000
            )
            */

        }
        catch (e)
        {
            const msg = this.le.messages[0];            
            this.props.popupErrorMessage(msg.messages);
        }

    }
    deleteOrders(orders,okDel) {
        try {

            let orderNums = []
         

            orders.forEach((el) => {
                if (el.orderStatus == 'error' || el.orderStatus=='todo'
                    || el.pickStatus == 'error' || el.pickStatus=='' || el.pickStatus=='Da Inviare')
                    orderNums.push(el.orderNum);
            });

            if (orderNums.length == 0) {
                this.props.popupErrorMessage();
                return;
            }

            this.props.loaderShow(0);

            deleteOrders(orderNums, this.uc.jwtToken,
                ok => {
                    this.props.loaderHide();
                    const msg = this.le.messages[1];
                    let obj = {
                        title: msg.captions[0],
                        width: "35%",
                        icon: "info",
                        messages: msg.messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                    };
                    this.props.popUp(obj);
                    okDel.call(this);
                },
                error => {
                    this.props.loaderHide();
                    const msg = this.le.messages[0];
                    let messages = error !== undefined && error != null && error.hasOwnProperty("errorMessage") ?
                        [error.errorMessage] : msg.messages;
                    this.props.popupErrorMessage(messages);

                });

        }
        catch (e)
        {
            this.props.loaderHide();

        }

    }
    sendOrders(okFn, koFn) {
        
        let orderNums = []
        let orders = this.findSelectedOrders();

        orders.forEach((el) => {
            if (el.pickStatus == 'Da Inviare' && el.orderStatus=='generated')
                orderNums.push(el.orderNum);
        });

        if (orderNums.length == 0) {
            this.props.popupErrorMessage(this.le.noSendableOrderSelected);
            return;
        }

        this.props.loaderShow(0);
        var data = { orderNums: orderNums };
     

        ajax(this, { method: 'post', url: 'api/order/order-shipment-start/noall', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: data },
            response => {
                if (typeof okFn === "function") okFn.call(this);
            },
            error => {
                this.props.loaderHide();
                const msg = this.le.messages[0];

                let messages = undefined && error != null && error.hasOwnProperty("errorMessage") ?
                    [error.errorMessage] : msg.messages;
                this.props.popupErrorMessage(messages);

                if (typeof koFn === "function") koFn.call(this, error);
            }
        );
    }
    sendAllOrders(okFn, koFn) {

        let orderNums = []
        let orders = this.findSelectedOrders();

        this.props.loaderShow(1);
        var data = { };


        ajax(this, { method: 'post', url: 'api/order/order-shipment-start/all', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: data },
            response => {
                this.props.loaderHide();
                if (typeof okFn === "function") okFn.call(this);
            },
            error => {
                this.props.loaderHide();
                const msg = this.le.messages[0];
                let messages = undefined && error != null && error.hasOwnProperty("errorMessage") ?
                    [error.errorMessage] : msg.messages;
                this.props.popupErrorMessage(messages);


                if (typeof koFn === "function") koFn.call(this, error);
            }
        );
    }
    getData(navigation) {
        this.props.loaderShow(1);

        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/list/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                
                const entries = response.data.result.orders.map(el => ([
                    el.orderNum, plainDate(el.orderDate), el.carrierName, el.customer,
                    {
                        color: LabelStatusColor[el.orderStatus] || "#000",
                        val: Languages.LabelStatusDescription[Languages.selectedLanguage][el.orderStatus] || el.orderStatus
                    }, {
                        color: LabelStatusColor[el.orderStatus] || "#000",
                        val: this.le.labelDownloadedStatuses[el.labelDownloaded ? 1 : 0]
                    },
                    {
                        color: LabelStatusColor[el.pickStatus] || "#000",
                        val: Languages.LabelStatusDescription[Languages.selectedLanguage][el.pickStatus] || el.pickStatus
                    },
                    {
                        label: el.orderStatus == "error" || el.pickStatus == "error" ? this.le.listButtonDelete :
                            (el.orderStatus == "generated" ? this.le.listButton:"")
                            ,
                        class: el.orderStatus == "error" || el.pickStatus == "error" ? "delete" : "download",
                        value: el.orderStatus == "error" || el.pickStatus == "error" ? "Elimina" : (el.orderStatus == "generated" ? "Scarica" : "")
                    }
                    
                ]));
                navigation.totalItems.value = response.data.result.totItems;

                this.setState({
                    entries: entries,
                    orders: response.data.result.orders,
                    managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                    navigation: navigation
                });
                
            },
            error => {
                const msg = this.le.messages[0];
                this.props.popupErrorMessage(msg.messages);
                
            },
            () => {
                this.props.loaderHide();
                
            }
        );
    }

    //#endregion Events

    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    //#region Events

    componentDidMount() {

        this.getData(this.state.navigation);
    }

    operationsClick(ev, operation) {
        switch (operation) {
            case 'send':
                this.sendOrders(
                    response => {
                        this.getData(this.state.navigation);
                    },
                    error => {
                        this.props.popupErrorMessage();
                    }
                );
                break;
            case 'sendAll':
                this.sendAllOrders(
                    response => {
                        this.getData(this.state.navigation);
                    },
                    error => {
                        this.props.popupErrorMessage();
                    }
                );
                break;
            case 'delete':
                this.deleteOrders(this.findSelectedOrders(),
                    ok => {
                        this.getData(this.state.navigation);
                    },
                    error => {
                        this.props.popupErrorMessage();
                    });
                break;
            
            case 'labels':
               
                this.downloadLabels(this.findSelectedOrders());
                break;
        }
    }

    listChange(ev, name, value, source) {
        let managers = JSON.parse(JSON.stringify(this.state.managers)), entries = JSON.parse(JSON.stringify(this.state.entries));
        const row = (source === "##header##" ? -1 : entries.findIndex((el) => (el[this.listKey] === source))), col = this.dataIndexes.find((el) => (el.name === name));
        if (col.manage>0) {
            if (name === "main" && row === -1) {
                managers = managers.map(function (el) {
                    el[col.idx] = value;
                    return el;
                });
            }
            else managers[row + 1][col.idx] = value;


            if (managers.filter(function (el) { return el[1] == true }).length == 1 && managers[0][1]) {
                managers[0][1] = false;
            }

            this.setState({ managers: managers });
        }
        else {
            entries[row][col.idx] = value;
            this.setState({ entries: entries });
        }
    }

    listClick(ev, name, value, source) {
        let action = ev.target.name;
        let order = this.findOrder(value);

        if (order == null)
            return;

        if (action == "delete") {
            this.deleteOrders([order], ok => {
                this.getData(this.state.navigation);
            });
        }
        else {
            this.downloadLabels([order]);
        }
    }

    render() {

        let filters = {};
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);

        if (this.uc.userRole !== ProfileLevels[2]) {
            return <div className="page-order-history">
                <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersList} />

                <UIFilterPanel>
                    {pageFilters}
                </UIFilterPanel>

                <div className="page-content">

                    <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />
                    <UIButtonPad align="right">
                        <UIButton key="btn-0" className="confirm" text={this.le.buttons[0]} onClick={(ev) => (this.operationsClick(ev, 'labels'))} />
                        <UIButton key="btn-1" className="confirm" text={this.le.buttons[1]} onClick={(ev) => (this.operationsClick(ev, 'send'))} />
                        <UIButton key="btn-2" className="confirm" text={this.le.buttons[3]} onClick={(ev) => (this.operationsClick(ev, 'sendAll'))} />
                        <UIButton key="btn-3" className="delete" text={this.le.listButtonDelete} onClick={(ev) => (this.operationsClick(ev, 'delete'))} />
                    </UIButtonPad>
                </div>
            </div>;
        }
        else {
            return <div className="page-order-history">
                <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersList} />

                <UIFilterPanel>
                    {pageFilters}
                </UIFilterPanel>

                <div className="page-content">
                    <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />
                </div>
            </div>;
        }
    }
}












